import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { patientFeedBackData } from "../../fourthUtils/constant";

const PatientFeedback = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000
    }
    return (
        <div className="frth-des-feedback">
            <div className="frth-des-feedback-header">
                <h2>
                    {selectedLanguage?.txt_what_our_patients_say_about_us}
                </h2>
                <hr />
            </div>
            <Slider className="fourth-design-feedback-slider frth-des-dots" {...settings}>
                {
                    patientFeedBackData?.map((v, i) => {
                        return (
                            <div className="fourth-design-patient-feedback-slider-text" key={i}>
                                <p>
                                    {isELSelect ? v?.caption : (isAlSelect ? v?.alCaption : v?.glCaption)}
                                </p>
                                <div>
                                    <img src={v?.img} alt="" />
                                    <h2>
                                        {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                    </h2>
                                </div>
                            </div>
                        )
                    })
                }
            </Slider>
        </div>
    )
}

export default PatientFeedback